import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useCallback, useEffect, useMemo, useRef } from 'react';
import { EAdfoxAnalyticsPayloadType } from '../../enums/EAdfoxAnalyticsPayloadType';
import { EBannerSource } from '../../enums/EBannerSource';
import { useIntersectionObserver } from '../../hooks/useIntersectionObserver';
import { getJsonFields, getJsonFields__DEPRECATED } from '../getJsonFields';
import { parseDecodeParams } from '../parseDecodeParams';
import { sendTeaserAdfoxEventFactory } from '../sendTeaserEvent';
import { sendTeaserWebAdfoxEventFactory } from '../sendTeaserWebEvent';
import { jsx as _jsx } from "react/jsx-runtime";
export function withAdfoxPostViewAnalytics(WrappedComponent, analyticsData) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var onClick = analyticsData.onClick,
    onView = analyticsData.onView,
    onView1 = analyticsData.onView1,
    onView2 = analyticsData.onView2;
  var ComponentWithPostViewAnalytics = function ComponentWithPostViewAnalytics(props) {
    var params = props.params,
      onError = props.onError,
      onLoad = props.onLoad,
      onRender = props.onRender,
      onStub = props.onStub,
      onRegistered = props.onRegistered,
      onLoadStable = props.onLoadStable;
    var timeoutsRef = useRef({
      view1: null,
      view2: null
    });
    var iframeInnerElementRef = useRef(null);
    var middleAdfoxAnalyticsPayload = _objectSpread(_objectSpread({}, analyticsData), {}, {
      bannerSource: EBannerSource.Adfox,
      p1: params.p1,
      p2: params.p2,
      type: EAdfoxAnalyticsPayloadType.WithoutAdfoxData
    });
    var sendTeaserWebEventRef = useRef(sendTeaserWebAdfoxEventFactory(middleAdfoxAnalyticsPayload));

    /** @deprecated */
    var sendTeaserEventRef = useRef(sendTeaserAdfoxEventFactory(middleAdfoxAnalyticsPayload));
    var elementRef = useRef(null);
    var _useIntersectionObser = useIntersectionObserver({
        elementRef: elementRef,
        initSubscribeAvailable: false,
        observerOptions: {
          threshold: 0.5
        },
        onInViewport: function onInViewport() {
          onView === null || onView === void 0 || onView();

          /** @deprecated это вызов адаптер между двумя версиями событий, удалить, когда откажемся от старой версии событий (не легасного тизера)  */
          sendTeaserWebEventRef.current('show', true);
          sendTeaserEventRef.current('show');
          timeoutsRef.current.view1 = setTimeout(function () {
            timeoutsRef.current.view2 = setTimeout(function () {
              onView2 === null || onView2 === void 0 || onView2();
              sendTeaserWebEventRef.current('show2');
            }, 1000);
            onView1 === null || onView1 === void 0 || onView1();
            sendTeaserWebEventRef.current('show1');
          }, 1000);
        },
        onOutViewport: function onOutViewport(_ref) {
          var observer = _ref.observer,
            setSubscribeUnavailable = _ref.subscribeState.setSubscribeUnavailable,
            intersectionsCount = _ref.intersectionsCount;
          if (intersectionsCount.inView) {
            observer.disconnect();
            setSubscribeUnavailable();
            clearTimeouts(timeoutsRef);
          }
        }
      }),
      subscribeState50PercentVisibility = _useIntersectionObser.subscribeState;
    var _useIntersectionObser2 = useIntersectionObserver({
        elementRef: elementRef,
        initSubscribeAvailable: false,
        observerOptions: {
          threshold: 0.01
        },
        onInViewport: function onInViewport(_ref2) {
          var observer = _ref2.observer,
            setSubscribeUnavailable = _ref2.subscribeState.setSubscribeUnavailable;
          sendTeaserWebEventRef.current('show_1px');
          observer.disconnect();
          setSubscribeUnavailable();
        }
      }),
      subscribeState1PercentVisibility = _useIntersectionObser2.subscribeState;
    var handleClick = useCallback(function (event) {
      sendTeaserWebEventRef.current('click');
      /** @deprecated это вызов адаптер между двумя версиями событий, удалить, когда откажемся от старой версии событий (не легасного тизера)  */
      sendTeaserWebEventRef.current('click', true);
      sendTeaserEventRef.current('click');
      onClick === null || onClick === void 0 || onClick(event);
    }, []);
    useEffect(function () {
      return function () {
        if (iframeInnerElementRef.current) {
          iframeInnerElementRef.current.removeEventListener('click', handleClick);
        }
        clearTimeouts(timeoutsRef);
      };
    }, []);
    var handleLoad = useCallback(function (data, containerId) {
      var bundleParams = data.bundleParams,
        bundleName = data.bundleName;
      var _parseDecodeParams = parseDecodeParams(data),
        parsedDecodedParams = _parseDecodeParams.parsedDecodedParams,
        internalBannerErrorData = _parseDecodeParams.internalBannerErrorData;
      var finalAdfoxAnalyticsPayload = _objectSpread(_objectSpread({}, middleAdfoxAnalyticsPayload), {}, {
        bundleName: bundleName,
        campaignId: bundleParams.campaignId,
        id: Number(bundleParams.bannerId),
        jsonFields: getJsonFields(parsedDecodedParams)
      }, internalBannerErrorData ? _objectSpread({
        type: EAdfoxAnalyticsPayloadType.ErrorWithAdfoxData
      }, internalBannerErrorData) : {
        type: EAdfoxAnalyticsPayloadType.WithAdfoxData
      });
      sendTeaserWebEventRef.current = sendTeaserWebAdfoxEventFactory(finalAdfoxAnalyticsPayload);
      sendTeaserEventRef.current = sendTeaserAdfoxEventFactory(_objectSpread(_objectSpread({}, finalAdfoxAnalyticsPayload), {}, {
        jsonFields: getJsonFields__DEPRECATED(parsedDecodedParams)
      }));
      sendTeaserWebEventRef.current('load');
      /** @deprecated это вызов адаптер между двумя версиями событий, удалить, когда откажемся от старой версии событий (не легасного тизера)  */
      sendTeaserWebEventRef.current('load', true);
      sendTeaserEventRef.current('load');
      subscribeState50PercentVisibility.setSubscribeAvailable();
      subscribeState1PercentVisibility.setSubscribeAvailable();
      onLoad === null || onLoad === void 0 || onLoad(data, containerId);
    }, []);
    var handleStub = useCallback(function (containerId) {
      sendTeaserWebEventRef.current('stub');
      onStub === null || onStub === void 0 || onStub(containerId);
    }, []);
    var handleError = useCallback(function (error, containerId) {
      sendTeaserWebEventRef.current = sendTeaserWebAdfoxEventFactory(_objectSpread(_objectSpread({}, middleAdfoxAnalyticsPayload), {}, {
        errorMessage: error.message,
        errorType: error.type,
        type: EAdfoxAnalyticsPayloadType.WithAdfoxErrorData
      }));
      sendTeaserWebEventRef.current('error');
      onError === null || onError === void 0 || onError(error, containerId);
    }, []);
    var handleRender = useCallback(function (containerId) {
      /**
       * @description Что тут Происходит и зачем это нужно, почему просто не отлавливать клики на баннеры?
       * Это нужно в случае, когда мы имеем дело с html банерами, которые могут быть вложены в iframe.
       * В таком случае, клики на баннеры не будут отлавливаться, так как они будут обрабатываться внутри iframe.
       * Поэтому, если внутри контейнера есть iframe, то мы отлавливаем клики на нем.
       */

      var iframeElement = document.querySelector("#".concat(containerId, " iframe"));
      if (iframeElement) {
        var _iframeElement$conten, _iframeDocument$query;
        var iframeDocument = iframeElement.contentDocument || ((_iframeElement$conten = iframeElement.contentWindow) === null || _iframeElement$conten === void 0 ? void 0 : _iframeElement$conten.document);
        var iframeBodyElement = (_iframeDocument$query = iframeDocument === null || iframeDocument === void 0 ? void 0 : iframeDocument.querySelector('body')) !== null && _iframeDocument$query !== void 0 ? _iframeDocument$query : null;
        iframeInnerElementRef.current = iframeBodyElement;
        if (iframeInnerElementRef.current) {
          iframeInnerElementRef.current.addEventListener('click', handleClick);
        }
      }
      onRender === null || onRender === void 0 || onRender(containerId);
    }, []);
    var handleRegistered = useCallback(function (containerId) {
      onRegistered === null || onRegistered === void 0 || onRegistered(containerId);
    }, []);
    var wrappedComponent = useMemo(function () {
      var wrappedComponentProps = _objectSpread(_objectSpread({}, props), {}, {
        lazyLoad: {
          fetchMargin: 100,
          mobileScaling: 1
        },
        onError: handleError,
        onLoad: handleLoad,
        onLoadStable: onLoadStable,
        onRegistered: handleRegistered,
        onRender: handleRender,
        onStub: handleStub
      });
      return /*#__PURE__*/_jsx(WrappedComponent, _objectSpread({}, wrappedComponentProps));
    }, []);
    return /*#__PURE__*/_jsx("div", {
      className: options.wrapperClassName,
      ref: elementRef,
      style: options.wrapperStyles,
      onClick: function onClick(e) {
        if (!iframeInnerElementRef.current) {
          handleClick(e);
        }
      },
      children: wrappedComponent
    });
  };
  var displayName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
  ComponentWithPostViewAnalytics.displayName = "withPostViewAnalytics(".concat(displayName, ")");
  return ComponentWithPostViewAnalytics;
}
function clearTimeouts(timeoutsRef) {
  if (timeoutsRef.current.view1 !== null) {
    clearTimeout(timeoutsRef.current.view1);
    timeoutsRef.current.view1 = null;
  }
  if (timeoutsRef.current.view2 !== null) {
    clearTimeout(timeoutsRef.current.view2);
    timeoutsRef.current.view2 = null;
  }
}